module.exports = __webpack_public_path__ + "img/1-8.ed6bcf6b.png";